import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/car/seizedcarprint',
  title: '打印查扣车表单',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
